import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'soggetto';

const aggiornaSoggetto = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "process" , data: params}, callback);
const getSoggettoPresente = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "soggetto_presente" , data: params}, callback);
const getSoggettoData = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "api" , data: params}, callback);
const inviaInvito = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "ricorda_link" , data: params}, callback);
const abilitaAccessoAPratica = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "abilita_accesso_pratica" , data: params}, callback);
const revocaAccessoAPratica = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "scollega_pratica" , data: params}, callback);
const deleteSoggetto = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "delete" , data: params}, callback);
const getRubrica = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_rubrica" , data: params}, callback);
const getSoggettoPerCF = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_soggetto_per_cf" , data: params}, callback);
const sincronizzaSoggetti = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "sincronizza_soggetti" , data: params}, callback);

const apiEndpoint = {
  aggiornaSoggetto,
  getSoggettoPresente,
  getSoggettoData,
  inviaInvito,
  abilitaAccessoAPratica,
  revocaAccessoAPratica,
  deleteSoggetto,
  getRubrica,
  getSoggettoPerCF,
  sincronizzaSoggetti
}

export default apiEndpoint;